import styled from "styled-components";

const Divider = styled.div`
  height: 1px;
  background: #000;
`;

export default Divider;
